import { render, staticRenderFns } from "./SmtpSettings.vue?vue&type=template&id=350a5dff&scoped=true&"
import script from "./SmtpSettings.vue?vue&type=script&lang=js&"
export * from "./SmtpSettings.vue?vue&type=script&lang=js&"
import style0 from "./SmtpSettings.vue?vue&type=style&index=0&id=350a5dff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350a5dff",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('350a5dff')) {
      api.createRecord('350a5dff', component.options)
    } else {
      api.reload('350a5dff', component.options)
    }
    module.hot.accept("./SmtpSettings.vue?vue&type=template&id=350a5dff&scoped=true&", function () {
      api.rerender('350a5dff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/settings/inbox/SmtpSettings.vue"
export default component.exports